import { IRoute } from '@/store/models/route.model';
import { IBaseAction, IBaseState } from '@/store/types/base.state';

export enum RouteActionTypes {
  SET_ROUTE_TITLE = 'ROUTE.SET_TITLE',
  SET_ROUTE_PATH = 'SET_ROUTE_PATH',
  SET_ROUTE = 'SET_ROUTE',
}

export interface IRouteSuccess extends IBaseAction {
  type: typeof RouteActionTypes.SET_ROUTE;
  route: IRoute;
}

export interface IRouteTitleSuccess extends IBaseAction {
  type: typeof RouteActionTypes.SET_ROUTE_TITLE;
  title: string;
}

export interface IRoutePathSuccess extends IBaseAction {
  type: typeof RouteActionTypes.SET_ROUTE_PATH;
  path: string;
}

export type TRouteAction = IRouteSuccess | IRouteTitleSuccess | IRoutePathSuccess;

export interface IRouteState extends IBaseState {
  title: string;
  path: string;
}
